
  <soft-resource-container class="mt-3" [resource]="resource">
    @if (resource.hasValue()) {
      <div class="flex flex-col border rounded w-full p-1.5 bg-surface mb-3">
        <span class="text-sm color-light">{{ resource.value()?.artikel?.nummer }}</span>
        <span class="text-lg font-semibold">
        {{ resource.value()?.artikel?.artbez1 }}
      </span>
        <span class="text-sm color-light"> {{ resource.value()?.artikel?.artbez2 }}</span>
        <span class="text-sm color-light"> {{ resource.value()?.artikel?.artbez3 }}</span>
        <span class="text-sm color-light"> {{ resource.value()?.artikel?.artbez4 }}</span>
        <span class="text-sm color-light"> {{ resource.value()?.artikel?.artbez5 }}</span>

        @if ($safeNavigationMigration(resource.value().artikel?.beschreibung) | isDefinedNotEmpty) {
          <span
            class="text-sm color-light"
            [innerText]="$safeNavigationMigration(resource.value().artikel?.beschreibung)"
          ></span>
        }
      </div>
    }


    @if ($safeNavigationMigration(resource.value()?.einheitenAuswahl) | isDefinedNotEmpty) {
      <div class="flex overflow-y-auto max-h-[30vh]">
        <div class="flex flex-col gap-3">
          @for (einheit of resource.value()?.einheitenAuswahl; track einheit.einheit.id) {
            <soft-mengen-eingabe
              [value]="einheit.menge ?? 0"
              [minValue]="0"
              [einheit]="einheit.einheit.arteh"
              [float]="true"
              (valueChange)="updateEinheitAuswahlQuantity($event, einheit)"
            ></soft-mengen-eingabe>
          }
        </div>
      </div>

    } @else {
      <soft-mengen-eingabe
        [(value)]="quantity"
        [minValue]="0"
        [einheit]="$safeNavigationMigration(resource.value()?.einheit?.arteh)"
        [float]="true"
      ></soft-mengen-eingabe>
    }
  </soft-resource-container>


<ng-template #bottomTemplate>
  <button
    class="soft-button primary w-full h-14 mt-3 mb-1"
    [disabled]="resource.isLoading() || quantity() <= 0"
    (click)="closeModal()"
  >
    Bewegung erstellen
  </button>
</ng-template>

